export const createWorker = () =>
  new Worker(
    // @ts-ignore
    new URL('./settings.workflow.worker.ts', import.meta.url),
  );
